import { render, staticRenderFns } from "./ProductPaymentForm.vue?vue&type=template&id=6ed3277d&lang=pug"
import script from "./ProductPaymentForm.vue?vue&type=script&lang=js"
export * from "./ProductPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports